module.exports = "/lucky-balls/img/drum/drum_loop_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_003.png
// module id = 1018
// module chunks = 0